import { clearNewCustomerCreationResult } from "@/features/customers/new-customer/newCustomerCreationResult";
import { clearNewCustomerWizardDraft } from "@/features/customers/new-customer/newCustomerWizardDraft";
import { clearAdminAccessToken } from "./adminAccessToken";
import { clearAdminSessionActivity } from "./adminSessionActivity";
import { clearAdminSessionEmail } from "./adminSessionEmail";
import { clearAdminSessionRole } from "./adminSessionRole";

/** Clears admin session state (email, role, activity, draft creation payload). */
export function endAdminSession(): void {
  clearAdminAccessToken();
  clearAdminSessionEmail();
  clearAdminSessionRole();
  clearAdminSessionActivity();
  clearNewCustomerCreationResult();
  clearNewCustomerWizardDraft();
}
